const STORAGE_KEY = 'DOWNLOAD_APP_BANNER_SHOWED';

export const getDownloadAppBannerShowedConfig = (): boolean => Boolean(localStorage.getItem(STORAGE_KEY));

export const setDownloadAppBannerShowedConfig = (value?: boolean) => {
  if (value === undefined) localStorage.removeItem(STORAGE_KEY);
  else localStorage.setItem(STORAGE_KEY, `${value}`);
};
